import "./App.css";
import {
  Routes,
  Route,
} from "react-router-dom";
import Dashboard from "./pages/dashboard";
import Login from "./pages/Login";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <main className="w-full">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#333",
            color: "#fff",
          },
          success: {
            iconTheme: {
              primary: "green",
              secondary: "white",
            },
          },
        }}
      />
    </main>
  );
}

export default App;
